import { validateTimezone } from "@compass/shared/schema/timezone";
import { useCurrentUser } from "./useCurrentUser";

export const useUserTimezone = () => {
    const user = useCurrentUser();
    return validateTimezone(user?.calendarTimeZone);
};
